import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {
  ButtonActionWebsiteLink,
  CreateWebsiteLinkData,
  WebsiteLinkData
} from "../../types/mb-website-links-modal.types";
import {defaultWebsiteLinksData} from "../../configs/default-website-link-data";
import {MbWebsiteLinksModalService} from "../../services/mb-website-links-modal.service";
import {websiteLinkFormFields} from "../../configs/website-link-form-fields";
import {ModalsService} from "../../../../../../../../core/services/modals.service";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'div[app-website-link-form]',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIconButton,
    MatIcon
  ],
  templateUrl: './website-link-form.component.html',
  styleUrl: './website-link-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebsiteLinkFormComponent {
  websiteLinkData = input<WebsiteLinkData>(defaultWebsiteLinksData);
  websiteLinkFormGroup = input<FormGroup>(new FormGroup({}));
  parentId = input<number>(0);
  isEditModeActive = input<boolean>(false);
  columnKey = input<string>('');
  noFirstData = input<boolean>(false);
  updateWebsiteLink = output<WebsiteLinkData>();
  deleteWebsiteLink = output<void>();

  private mbWebsiteLinksModalService: MbWebsiteLinksModalService = inject(MbWebsiteLinksModalService);
  private modalService: ModalsService = inject(ModalsService);

  public readonly websiteLinkFormFields = websiteLinkFormFields;

  public getFormFieldClass(): string {
    if (!this.websiteLinkData().id) { return ''; }

    return 'none-pointer-events';
  }

  public async handleClick(key: ButtonActionWebsiteLink): Promise<void> {
    const actionMap = {
      save: () => this.createData(),
      delete: () => this.deleteWebsiteLink.emit(),
      history: () => this.openHistoryModal(),
      deleteCurrent: () => this.deleteCurrent()
    } as const;

    await actionMap[key]?.();
  }

  public handleValueClick(key: string): void {
    if(!this.websiteLinkData().id) { return; }

    window.open(this.websiteLinkFormGroup().get(key)?.value, '_blank')?.focus();
  }

  private async createData(): Promise<void> {
    const params: CreateWebsiteLinkData = {
      marketingBlockId: this.parentId(),
      ...this.websiteLinkFormGroup().value
    };

    const data = await this.mbWebsiteLinksModalService.createData(params).catch(() => defaultWebsiteLinksData);
    this.updateWebsiteLink.emit(data);
  }

  private async openHistoryModal(): Promise<void> {
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.websiteLinkData().history,
      columnKey: this.columnKey()
    });
  }

  private async deleteCurrent(): Promise<void> {
    await this.mbWebsiteLinksModalService.deleteRecord(this.websiteLinkData().id)
      .then(() => this.deleteWebsiteLink.emit());
  }
}
